import React, { useEffect } from "react";
import "./KaramaleTerms.css"; // Optional: add your styles here
import Header3 from "./components/Header3";
import Header from "./components/Header";
import Header2 from "./components/Header2";
import Header5 from "./components/Header5";

function KaramaleTerms() {
  useEffect(() => {
    document.title = "Karamale Terms and Conditions";
  }, []);
  return (
    <>
      {localStorage.getItem("customername") !== null ? (
        <Header2 />
      ) : localStorage.getItem("businessname") !== null ? (
        <Header3 />
      ) : localStorage.getItem("partner") !== null ? (
        <Header5 />
      ) : (
        <Header />
      )}
      <div className="container">
        <div className="row justify-content-center just-container-insid">
          <div className="col-lg-8 pl-0 pr-0">
            <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search">
              <h3>Karamale Terms and Conditions</h3>

              <section>
                <h4>1. Acceptance of Terms</h4>
                <p>
                  By accessing or using the Karamale platform, purchasing
                  tickets, or interacting with event listings, you agree to be
                  bound by these Terms and Conditions. If you do not agree,
                  please discontinue use.
                </p>
              </section>

              <section>
                <h4>2. Platform Usage</h4>
                <ul>
                  <li>
                    Must be 18+ or have parental consent to use the platform.
                  </li>
                  <li>
                    No unlawful usage including fraud, scalping, or event rule
                    violations.
                  </li>
                  <li>Karamale may suspend accounts violating these terms.</li>
                </ul>
              </section>

              <section>
                <h4>3. Ticket Purchase & Delivery</h4>
                <ul>
                  <li>
                    All purchases are final unless eligible under our{" "}
                    <a href="/refund-policy">Refund Policy</a>.
                  </li>
                  <li>
                    Digital tickets are delivered to your Karamale account as QR
                    codes.
                  </li>
                  <li>
                    Actual (printed) tickets are only issued for events with
                    offline support.
                  </li>
                </ul>
              </section>

              <section>
                <h4>4. Ticket Ownership & Restrictions</h4>
                <ul>
                  <li>
                    Tickets are non-transferable unless allowed by the
                    organiser.
                  </li>
                  <li>
                    Resale or promotional use without consent is prohibited.
                  </li>
                  <li>Tickets from unauthorized sellers may be invalid.</li>
                </ul>
              </section>

              <section>
                <h4>5. Event Changes & Cancellations</h4>
                <ul>
                  <li>
                    Organisers may alter event details. We'll notify affected
                    buyers via email, SMS, or dashboard alerts.
                  </li>
                  <li>
                    Refer to our <a href="/refund-policy">Refund Policy</a> for
                    cancellation procedures.
                  </li>
                </ul>
              </section>

              <section>
                <h4>6. Liability & Disclaimer</h4>
                <ul>
                  <li>
                    Karamale is not liable for event safety, quality, or
                    third-party services.
                  </li>
                  <li>
                    Tickets lost, stolen, or damaged are the user's
                    responsibility.
                  </li>
                  <li>Use of the platform is at your own risk.</li>
                </ul>
              </section>

              <section>
                <h4>7. Privacy & Data</h4>
                <p>
                  By using Karamale, you consent to our data practices as
                  outlined in the
                  <a href="/privacy-policy" target="_blank">
                    {" "}
                    Privacy Policy
                  </a>
                  . We do not sell personal data to third parties.
                </p>
              </section>

              <section>
                <h4>8. Intellectual Property</h4>
                <p>
                  All content on the Karamale platform is owned by Karamale or
                  its licensors. You may not copy or redistribute platform
                  materials without written permission.
                </p>
              </section>

              <section>
                <h4>9. Updates to Terms</h4>
                <p>
                  These Terms may be updated periodically. Continued use after
                  changes constitutes acceptance.
                </p>
              </section>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default KaramaleTerms;
